import firebase from 'firebase/compat/app';
import { getRemoteConfig } from 'firebase/remote-config';
import { fetchAndActivate, getValue } from 'firebase/remote-config';

import 'firebase/compat/auth';
import 'firebase/compat/firestore';

let cachedRemoteConfigObject = {};

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
};

const Firebase = firebase.initializeApp(firebaseConfig);

// Initialize Remote Config
const firebaseRemoteConfig = getRemoteConfig(Firebase);

// Set default settings for Remote Config (optional)
firebaseRemoteConfig.settings = {
    fetchTimeoutMillis: 60000, // Increase timeout to 60 seconds
    minimumFetchIntervalMillis: 60000, // Set minimum fetch interval to 1 minutes cache
};

export const fetchRemoteConfigData = async (configDataType) => {
    try {
        if (cachedRemoteConfigObject && cachedRemoteConfigObject[configDataType]) {
            return cachedRemoteConfigObject[configDataType]; // Return the cached value
        }

        await fetchAndActivate(remoteConfig); // Fetch and activate remote config values
        const fetchedValue = JSON.parse(getValue(remoteConfig, configDataType).asString());
        
        // Store in cache with configDataType as key
        cachedRemoteConfigObject[configDataType] = fetchedValue;

        return fetchedValue; // Return the fetched value
    } catch (error) {
        console.error('Error fetching remote config:', error);
        return null;
    }
};

export const firestore =  Firebase.firestore();
export const remoteConfig = firebaseRemoteConfig;